/* eslint-disable import/no-commonjs */
exports.wrapPageElement = require('./src/wrap-page');
